import Helper from '@ember/component/helper';
import { isNone } from '@ember/utils';

export function classifyNumber([number], { lower = -0.01, upper = 0.01 } = {}) {
  if (isNaN(number) || isNone(number)) {
    return;
  } else if (number < lower) {
    return 'is-error';
  } else if (number > upper) {
    return 'is-success';
  } else {
    return 'is-pending';
  }
}

/*
  Basic Usage:

  ```handlebars
  <div class={{classify-number number lower=0.05 upper=0.95}}>{{pct number}}</div>
  ```
*/
export default Helper.helper(classifyNumber);
